import ClientAgentExtender from '../../../Common/clientAgentExtender'

export default class RoamingProfili extends ClientAgentExtender {
  _idPrikljucek = null
  _stevilka = null
  _seznam = null
  _vklopljen = null
  _vklopljenOperaterskiRoamingProfil = false
  _loading = false

  constructor (idPrikljucek, stevilka) {
    super()
    this._idPrikljucek = idPrikljucek
    this._stevilka = stevilka
  }

  async loadList (override = false) {
    if (this._seznam === null || override) {
      let response = await this.ca.makeRequest(
        'prikljucek/telefonija/umts/pridobiRoamingProfile',
        {idPrikljucek: this._idPrikljucek, stevilka: this._stevilka},
        'GET'
      )
      this._seznam = response.data
      response.data.forEach((item) => {
        if (item.vklopljen) {
          this._vklopljen = item
        }
        if (item.vklopljenOperatersko) {
          this._vklopljen = item
          this._vklopljenOperaterskiRoamingProfil = true
        }
      })
    }
  }

  async spremeniProfil (profil) {
    if (!this._vklopljenOperaterskiRoamingProfil) {
      this._loading = true
      await this.ca.makeRequest(
        'prikljucek/telefonija/umts/shraniRoamingProfil',
        {idPrikljucek: this._idPrikljucek, stevilka: this._stevilka, idProfil: profil.idProfil},
        'GET'
      )
      await this.loadList(true)
      this._loading = false
    }
  }

  get seznam () {
    return this._seznam
  }

  set seznam (value) {
    this._seznam = value
  }

  get vklopljen () {
    return this._vklopljen
  }

  set vklopljen (value) {
    this._vklopljen = value
  }

  get vklopljenOperaterskiRoamingProfil () {
    return this._vklopljenOperaterskiRoamingProfil
  }

  set vklopljenOperaterskiRoamingProfil (value) {
    this._vklopljenOperaterskiRoamingProfil = value
  }

  get loading () {
    return this._loading
  }

  set loading (value) {
    this._loading = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Prikljucek/Telefonija/Umts/RoamingProfili.js